import { render, staticRenderFns } from "./MiddleBlock.vue?vue&type=template&id=0a5179df"
import script from "./MiddleBlock.vue?vue&type=script&lang=js"
export * from "./MiddleBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports